<!-- ============================================================================
     AI-JAVADOC: EuStaticNotificationObjectComponent Template
     Component: EuStaticNotificationObjectComponent
     Module: EU (End User)
     Description: Object detail view for EuStaticNotification with three navigation tabs:
                  - Vertragspersonen: Contract person type assignments
                  - Vertragstypen: Contract type assignments
                  - Versicherte Objekttypen: Insurable object type assignments
     ============================================================================ -->

@if (initialized && dto) {

    <!-- ==================== Tab: Vertragspersonen ==================== -->
    @if (activeNavigationItems?.action == 'eu.EuStaticNotificationContractPersonType') {
        <div class="p-3">
            @if (contractPersonTypeWidget) {
                <mvs-widget [widgetData]="contractPersonTypeWidget"></mvs-widget>
            }
        </div>
    }

    <!-- ==================== Tab: Vertragstypen ==================== -->
    @if (activeNavigationItems?.action == 'eu.EuStaticNotificationContractType') {
        <div class="p-3">
            @if (contractTypeWidget) {
                <mvs-widget [widgetData]="contractTypeWidget"></mvs-widget>
            }
        </div>
    }

    <!-- ==================== Tab: Versicherte Objekttypen ==================== -->
    @if (activeNavigationItems?.action == 'eu.EuStaticNotificationInsurableObjectType') {
        <div class="p-3">
            @if (insurableObjectTypeWidget) {
                <mvs-widget [widgetData]="insurableObjectTypeWidget"></mvs-widget>
            }
        </div>
    }

}
